import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function SeriesBanner() {
  return (
    <section data-testid="series-banner-section" className="pt-2 pb-6 sm:pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="group">
            <Link to="/books" data-testid="series-banner-link" className="block">
              <img
                src="/images/series-banner.webp"
                alt="The Bailey Adventure Book Series — all five books together: Bailey: What Can You Do?, Bailey's Affirmations, Bailey Visits the Dentist, Bailey Starts School, and Bailey in London"
                className="w-full rounded-[2rem] border-2 border-sand shadow-[0_30px_60px_-20px_rgba(49,67,92,0.25)] transition-transform duration-500 group-hover:scale-[1.01]"
              />
            </Link>
            <div className="mt-6 flex justify-center">
              <Link
                to="/books"
                data-testid="series-banner-cta"
                className="inline-flex items-center gap-2 rounded-full bg-terracotta text-cream font-display font-bold text-sm sm:text-base px-8 py-3.5 shadow-[0_16px_32px_-12px_rgba(79,163,227,0.7)] hover:bg-terracottadark hover:gap-3 transition-all"
              >
                Shop the series <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
